import { render, staticRenderFns } from "./ApplicationEventsList.vue?vue&type=template&id=20c05352"
import script from "./ApplicationEventsList.vue?vue&type=script&lang=js"
export * from "./ApplicationEventsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports